var _path, _path2, _rect, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcGoal(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.97 20.9628L18.554 30.4181C17.8608 31.4396 18.5925 32.8204 19.827 32.8204H33.5078C34.7423 32.8204 35.474 31.4396 34.7809 30.4181L28.3648 20.9628C27.5509 19.7635 25.7838 19.7635 24.97 20.9628Z",
    fill: "#AFF1D1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4789 18.5805L6.11132 29.5228C5.07915 30.8726 6.04158 32.8202 7.74077 32.8202H26.1056C27.8047 32.8202 28.7672 30.8726 27.735 29.5228L19.3673 18.5805C18.1358 16.97 15.7105 16.9701 14.4789 18.5805Z",
    fill: "#37DC8C"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.8965,
    y: 11.2817,
    width: 2.05128,
    height: 7.17949,
    rx: 1.02564,
    fill: "#BDD9FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3848 8.68457C15.3848 7.85318 16.0587 7.1792 16.8901 7.1792H21.5117C22.3014 7.1792 22.7108 8.12125 22.1721 8.69863L21.2937 9.63991C20.9699 9.98691 20.9699 10.5253 21.2937 10.8723L22.1721 11.8136C22.7108 12.391 22.3014 13.333 21.5117 13.333H16.8901C16.0587 13.333 15.3848 12.6591 15.3848 11.8277V8.68457Z",
    fill: "#5AA0FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGoal);
export default __webpack_public_path__ + "static/media/ic_goal.3c8d25803292a71e8c36eb09fd2da6dd.svg";
export { ForwardRef as ReactComponent };